import React, { FC } from 'react'
import clsx from 'clsx'

import { StandardProps } from '../../types/common'

import styles from './Avatar.module.scss'

interface AvatarProps extends StandardProps {
  alt: string
  src?: string
  size?: 'xxxs' | 'xxs' | 'xs' | 's' | 'xm' | 'm' | 'l'
}

const DEFAULT_AVATAR = 'assets/images/avatar.png'

export const Avatar: FC<AvatarProps> = ({
  src,
  alt,
  size = 'm',
  className,
  testid = 'avatar',
}) => {
  return (
    <div
      className={clsx(styles['hds-avatar'], styles[`hds-avatar_size_${size}`], className)}
      aria-label={alt}
      style={{ backgroundImage: `url(${src || DEFAULT_AVATAR})` }}
      data-testid={testid}
    />
  )
}
